// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2vl1q","col":"styles_col__1ipQC","fulfillmentStatus":"styles_fulfillmentStatus___VizA","emailCol":"styles_emailCol__1xnVw"};